export default __webpack_public_path__ + "static/media/set-short-3.26020946.png";